
export function morelessSetContent(editor, e) {
  const $ = editor.dom.$;
  $('[data-ke-type="moreLess"]', e.node).each((idx, elm) => {
    const $elm = $(elm);
    const $content = $elm.find('.moreless-content');
    if ($content.length > 0) {
      $elm.html($elm.find('.moreless-content').html());
    }
  })
}

export function morelessPreProcess(editor, e) {
  const $ = editor.dom.$
  $('[data-ke-type="moreLess"]', e.node).each((idx, elm) => {
    const $elm = $(elm);
    const content = $elm.html();
    $elm.html(`<a class="btn-toggle-moreless">더보기</a><div class="moreless-content">${content}</div>`);
  })
}
